import domready from "domready"
import SimplexNoise from "simplex-noise"
import "./style.css"
import { clamp } from "./util";
import AABB from "./AABB";

const PHI = (1 + Math.sqrt(5)) / 2;
const TAU = Math.PI * 2;
const DEG2RAD_FACTOR = TAU / 360;

const config = {
    width: 0,
    height: 0
};

/**
 * @type CanvasRenderingContext2D
 */
let ctx;
let canvas;

const noise = new SimplexNoise()
domready(
    () => {

        canvas = document.getElementById("screen");
        ctx = canvas.getContext("2d");

        const width = (window.innerWidth) | 0;
        const height = (window.innerHeight) | 0;

        config.width = width;
        config.height = height;

        canvas.width = width;
        canvas.height = height;

        ctx.fillStyle = "#000";
        ctx.fillRect(0,0, width, height);


        const noiseScale = 0.01
        const noiseScale2 = 0.01

        let imageData = ctx.createImageData(width, height);

        const { data } = imageData

        const fov = 60
        const aspectRatio = width/height

        const mm = new AABB();

        let off = 0;
        for (let y = 0; y < height; y++)
        {
            for (let x = 0; x < width; x++)
            {
                const r = 1000;

                const a = (fov * TAU / 360) * x / width
                const b = (fov/aspectRatio * TAU / 360) * y / height

                const nx0 = Math.cos(a) * r * noiseScale
                const nz0 = Math.sin(a) * r * noiseScale
                const ny0 = Math.sin(b) * r * noiseScale
                
                const curlFactor = 100
                const e = 0.1;
                const  n1 = noise.noise3D(nx0, ny0 + e, nz0);
                const  n2 = noise.noise3D(nx0, ny0 - e, nz0);
                const  n3 = noise.noise3D(nx0, ny0, nz0 + e);
                const  n4 = noise.noise3D(nx0, ny0, nz0 - e);
                const  n5 = noise.noise3D(nx0 + e, ny0, nz0);
                const  n6 = noise.noise3D(nx0 - e, ny0, nz0);

                const dx = n2 - n1 - n4 + n3;
                const dy = n4 - n3 - n6 + n5;
                const dz = n6 - n5 - n2 + n1;

                const f = curlFactor/Math.sqrt(dx*dx+dy*dy+dz*dz);

                const v = clamp(128 + 128 * noise.noise3D((x + f * dx) * noiseScale2,(y  + f * dy)* noiseScale2, 1 ));


                mm.add(v,0)
                
                data[off    ] = v
                data[off + 1] = v
                data[off + 2] = v
                data[off + 3] = 255
                off += 4
            }
        }

        console.log(mm.minX, mm.maxX)

        ctx.putImageData(imageData, 0, 0)


    }
);
